// @generated by protoc-gen-connect-query v0.4.1
// @generated from file admin/v1/identities.proto (package admin.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { createQueryService } from "@bufbuild/connect-query";
import { MethodKind } from "@bufbuild/protobuf";
import { CreateGroupRequest, CreateGroupResponse, DeleteGroupRequest, DeleteGroupResponse, GetGroupByIdRequest, GetGroupByIdResponse, LinkUsersToGroupRequest, LinkUsersToGroupResponse, ListGroupsRequest, ListGroupsResponse, UnlinkUsersFromGroupRequest, UnlinkUsersFromGroupResponse, UpdateGroupRequest, UpdateGroupResponse } from "@buf/formal_admin.bufbuild_es/admin/v1/identities_pb.js";

export const typeName = "admin.v1.GroupService";

/**
 * @generated from rpc admin.v1.GroupService.CreateGroup
 */
export const createGroup = createQueryService({
  service: {
    methods: {
      createGroup: {
        name: "CreateGroup",
        kind: MethodKind.Unary,
        I: CreateGroupRequest,
        O: CreateGroupResponse,
      },
    },
    typeName: "admin.v1.GroupService",
  },
}).createGroup;

/**
 * @generated from rpc admin.v1.GroupService.ListGroups
 */
export const listGroups = createQueryService({
  service: {
    methods: {
      listGroups: {
        name: "ListGroups",
        kind: MethodKind.Unary,
        I: ListGroupsRequest,
        O: ListGroupsResponse,
      },
    },
    typeName: "admin.v1.GroupService",
  },
}).listGroups;

/**
 * @generated from rpc admin.v1.GroupService.GetGroupById
 */
export const getGroupById = createQueryService({
  service: {
    methods: {
      getGroupById: {
        name: "GetGroupById",
        kind: MethodKind.Unary,
        I: GetGroupByIdRequest,
        O: GetGroupByIdResponse,
      },
    },
    typeName: "admin.v1.GroupService",
  },
}).getGroupById;

/**
 * @generated from rpc admin.v1.GroupService.UpdateGroup
 */
export const updateGroup = createQueryService({
  service: {
    methods: {
      updateGroup: {
        name: "UpdateGroup",
        kind: MethodKind.Unary,
        I: UpdateGroupRequest,
        O: UpdateGroupResponse,
      },
    },
    typeName: "admin.v1.GroupService",
  },
}).updateGroup;

/**
 * @generated from rpc admin.v1.GroupService.LinkUsersToGroup
 */
export const linkUsersToGroup = createQueryService({
  service: {
    methods: {
      linkUsersToGroup: {
        name: "LinkUsersToGroup",
        kind: MethodKind.Unary,
        I: LinkUsersToGroupRequest,
        O: LinkUsersToGroupResponse,
      },
    },
    typeName: "admin.v1.GroupService",
  },
}).linkUsersToGroup;

/**
 * @generated from rpc admin.v1.GroupService.UnlinkUsersFromGroup
 */
export const unlinkUsersFromGroup = createQueryService({
  service: {
    methods: {
      unlinkUsersFromGroup: {
        name: "UnlinkUsersFromGroup",
        kind: MethodKind.Unary,
        I: UnlinkUsersFromGroupRequest,
        O: UnlinkUsersFromGroupResponse,
      },
    },
    typeName: "admin.v1.GroupService",
  },
}).unlinkUsersFromGroup;

/**
 * @generated from rpc admin.v1.GroupService.DeleteGroup
 */
export const deleteGroup = createQueryService({
  service: {
    methods: {
      deleteGroup: {
        name: "DeleteGroup",
        kind: MethodKind.Unary,
        I: DeleteGroupRequest,
        O: DeleteGroupResponse,
      },
    },
    typeName: "admin.v1.GroupService",
  },
}).deleteGroup;
